export default {
      id: "icon-search-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }